import { useLocation } from 'react-router'
import { Country } from '../../constants'
import { useMemo } from 'react'

const useCountry = () => {
  const { pathname } = useLocation()

  return useMemo(() => {
    const rawCountry = pathname.split('/').filter(Boolean)[0]
    return (rawCountry?.trim()?.toUpperCase() || 'US') as Country
  }, [pathname])
}

export { useCountry }
